<p>
  Поддържането на сигурна и актуална парола е от съществено значение за защитата на вашия профил и лични данни.
  Препоръчваме ви редовно да сменяте паролата си, особено ако използвате една и съща комбинация в други сайтове или
  имате съмнения за неоторизиран достъп.
</p>
<h6 class="mt-3">Как да смените паролата си?</h6>
<ol>
  <li>
    Навигирайте до <strong>„Профил“</strong> в горното меню и изберете <strong>„Настройки“</strong>.
  </li>
  <li>
    В секцията <strong>„Настройки на профила“</strong>, намерете реда <strong>„Промяна на парола“</strong> и натиснете
    бутона <strong>„Промени“</strong>.
  </li>
  <li>
    В отворилия се прозорец попълнете следната информация:
    <ul>
      <li><strong>Текуща парола</strong> – за потвърждение на самоличността ви.</li>
      <li><strong>Нова парола</strong> – въведете нова, силна парола.</li>
      <li><strong>Повторете новата парола</strong> – за да избегнете грешки при въвеждането.</li>
    </ul>
  </li>
  <li>
    Натиснете <strong>„Запази“</strong>, за да финализирате промяната.
  </li>
</ol>
<h6 class="mt-3">Какво се случва след това?</h6>
<p>
  Новата ви парола ще бъде активна незабавно. При следващо влизане или потвърждение на важни действия (напр. покупка,
  наддаване, промяна на настройки), ще бъде необходимо да използвате новата парола.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Създайте силна парола с поне 8 символа, включваща комбинация от букви, цифри и специални
  символи. Избягвайте лесно предвидими комбинации като <em>123456</em> или <em>password</em>.
</div>
